import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet, Text, View } from 'react-native';

import Dialog from 'components/dialog';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';
import { useServiceModeContext } from 'state/service-mode';
import { primitive } from 'styles/constants';

import { ChangeStoreConfirmationDialogProps } from './types';

const messages: Record<
  string,
  Record<string, { id: TranslationKey | string; defaultMessage: string }>
> = {
  delivery: {
    buttonLabel: {
      id: 'changeRestaurantDialogConfirmButtonLabelDelivery',
      defaultMessage: 'Change Address',
    },
    headerText: {
      id: 'changeRestaurantDialogHeadingDelivery',
      defaultMessage: 'Change Address?',
    },
    bodyText: {
      id: 'changeRestaurantDialogBodyDelivery',
      defaultMessage:
        'Changing your address may result in differences in prices or item availability.',
    },
  },
  pickup: {
    buttonLabel: {
      id: 'changeRestaurantDialogConfirmButtonLabel',
      defaultMessage: 'Change Restaurant',
    },
    headerText: {
      id: 'changeRestaurantDialogHeading',
      defaultMessage: 'Change Restaurant',
    },
    bodyText: {
      id: 'changeRestaurantDialogBody',
      defaultMessage:
        'Changing your restaurant may result in differences in prices or item availability.',
    },
  },
};

export const ChangeStoreConfirmationDialog = ({
  onDismiss,
  onConfirm,
  showDialog,
}: ChangeStoreConfirmationDialogProps) => {
  const { isDelivery } = useServiceModeContext();

  const messageSet = isDelivery ? messages.delivery : messages.pickup;
  const buttonLabel = t(messageSet.buttonLabel.id, messageSet.buttonLabel.defaultMessage);
  const headerText = t(messageSet.headerText.id, messageSet.headerText.defaultMessage);
  const bodyText = t(messageSet.bodyText.id, messageSet.bodyText.defaultMessage);

  return (
    <Dialog
      showDialog={showDialog}
      headingComponent={
        <View style={styles.dialogHeaderContainer}>
          <Icon variant="errorFill" size="$11" />
          <Text style={styles.dialogHeaderText}>{headerText}</Text>
        </View>
      }
      bodyComponent={<Text style={styles.dialogBodyText}>{bodyText}</Text>}
      confirmButtonLabel={buttonLabel}
      confirmDialog={onConfirm}
      onDismiss={onDismiss}
      modalAppearanceEventMessage="Change Store Confirmation from Checkout"
      isErrorModal
      showCloseButton
    />
  );
};

const styles = StyleSheet.create({
  dialogHeaderText: {
    fontFamily: primitive.fontFamily.$headers,
    fontSize: 16,
    marginTop: 8,
    textAlign: 'center',
    color: primitive.$bbqBrown,
  },
  dialogHeaderContainer: {
    alignItems: 'center',
  },
  dialogBodyText: {
    fontFamily: primitive.fontFamily.$body,
    textAlign: 'center',
    marginVertical: 12,
    color: primitive.$bbqBrown,
  },
});
